import React, {useState} from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Home from "./components/home";
import Blog from "./components/Blogs/blog";
import Projects from "./components/projects";
import About from "./components/about";
import Resume from "./components/resume";
// import Footer from "./components/footer"

function App() {
    return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/blogs" element={<Blog />} />
          <Route exact path="/projects" element={<Projects />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/resume" element={<Resume />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
